import { platformBrowser } from '@angular/platform-browser';
import { AppModule } from './app/app-module';

// import { Buffer } from 'buffer';
import * as process from 'process';

// Patching de l'objet global window pour simuler Node.js
(window as any).global = window;
// (window as any).Buffer = Buffer;
(window as any).process = process;

platformBrowser().bootstrapModule(AppModule, {
  ngZoneEventCoalescing: true,
})
  .catch(err => console.error(err));

